var _path, _path2;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCopy = function SvgCopy(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none",
    viewBox: "0 0 18 17",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.36 0H6.023c-.466 0-.912.183-1.242.509-.33.325-.514.767-.514 1.227v9.227c0 .46.185.902.514 1.227.33.326.776.509 1.242.509h9.337c.466 0 .913-.183 1.242-.509.33-.325.515-.767.515-1.227V1.736c0-.46-.186-.902-.515-1.227A1.77 1.77 0 0 0 15.36 0m.25 10.963a.25.25 0 0 1-.073.175.25.25 0 0 1-.177.073H6.023a.25.25 0 0 1-.177-.073.25.25 0 0 1-.074-.175V1.736a.252.252 0 0 1 .251-.248h9.337c.066 0 .13.026.177.073.047.046.074.11.074.175z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.757 5.705h.552c.2 0 .391-.079.532-.218a.74.74 0 0 0 0-1.053.76.76 0 0 0-.532-.218h-.552c-.466 0-.913.183-1.242.509C.185 5.05 0 5.492 0 5.953v9.226c0 .46.185.902.515 1.228.329.325.776.508 1.242.508h9.336c.466 0 .913-.183 1.242-.508.33-.326.515-.768.515-1.228v-.595a.74.74 0 0 0-.22-.526.76.76 0 0 0-1.065 0 .74.74 0 0 0-.22.526v.595a.25.25 0 0 1-.074.175.25.25 0 0 1-.178.073H1.757a.25.25 0 0 1-.178-.073.25.25 0 0 1-.073-.175V5.953c0-.066.026-.13.073-.176a.25.25 0 0 1 .178-.072"
  })));
};
export default SvgCopy;